module.exports = __webpack_public_path__ + "static/img/far3_c.1eba899e.png";